import { render, staticRenderFns } from "./NewPropertyGroup.vue?vue&type=template&id=2409671e"
import script from "./NewPropertyGroup.vue?vue&type=script&lang=js"
export * from "./NewPropertyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports